import * as actions from './actions';
import * as constants from './constants';
import * as selectors from './selector';
import reducer from './reducer';

export default {
    actions,
    constants,
    selectors,
    reducer
};



// WEBPACK FOOTER //
// ./src/services/mea/index.js